"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _categoryConfig = _interopRequireDefault(require("../categoryConfig"));

var _constants = require("../constants");

var _SFLYMenuItems = _interopRequireDefault(require("../mocks/SFLYMenuItems"));

var _TPNEWMenuItems = _interopRequireDefault(require("../mocks/TPNEWMenuItems"));

var _helperUtil = require("../common/util/helperUtil");

var _fetchCatalogs = require("../common/fetchCatalogs");

var _promiseUtil = require("./util/promiseUtil");

var USE_MOCK_DATA_AFTER_MS = 200;
/**
 * CategoryDataCache
 *
 * Helper class for fetching category JSON and related data.
 */

var CategoryDataCache = /*#__PURE__*/function () {
  function CategoryDataCache(opts) {
    (0, _classCallCheck2.default)(this, CategoryDataCache);
    this.brandType = opts.brandType;
    this.enableLocalStorageCached = opts.enableLocalStorageCached;
    this.invalidCachedTimeCategories = opts.invalidCachedTimeCategories;
    this.invalidCachedTimeSubnavConfig = opts.invalidCachedTimeSubnavConfig;
    this.markInfo = opts.markInfo;
    this.loggerInstance = opts.loggerInstance;
    this.enableMockData = opts.enableMockData;
    this.fetchCatalogPromise = null;
    this.fetchFlyoutContentPromise = null;
  }

  (0, _createClass2.default)(CategoryDataCache, [{
    key: "getActiveContextStore",
    value: function getActiveContextStore() {
      if (!this.brandType) {
        return _categoryConfig.default.context.sfly;
      }

      return this.brandType === _constants.BRANDS.TINYPRINTS ? _categoryConfig.default.context.tp : _categoryConfig.default.context.sfly;
    }
    /**
     * Sort categories by rank in asc order
     * but place rank 0 category at the last (Ideas/Inspiration have rank=0 so we need these category at last )
     *
     *
     * @param {*} categories
     */

  }, {
    key: "sortCategoryByRank",
    value: function sortCategoryByRank(categories) {
      return categories.sort(function (a, b) {
        if (a.rank === b.rank) {
          return 0;
        }

        if (a.rank === 0) {
          return 1;
        }

        if (b.rank === 0) {
          return -1;
        }

        return a.rank - b.rank;
      });
    }
  }, {
    key: "getCategoryMockType",
    value: function getCategoryMockType() {
      if (!this.brandType) {
        return _SFLYMenuItems.default;
      }

      return this.brandType === _constants.BRANDS.TINYPRINTS ? _TPNEWMenuItems.default : _SFLYMenuItems.default;
    }
  }, {
    key: "getMockCatalog",
    value: function getMockCatalog() {
      return this.sortCategoryByRank(this.getCategoryMockType());
    }
    /**
     * Fetch the categories JSON. This is a private call wrapped by fetchCatalog()
     */

  }, {
    key: "_doFetchCatalog",
    value: function () {
      var _doFetchCatalog2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var activeContextStore, invalidCachedTime, localCategories, startTime, categories, dcSubnavConfig, timeDiff;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                activeContextStore = this.getActiveContextStore();
                invalidCachedTime = this.invalidCachedTimeCategories;
                localCategories = this.enableLocalStorageCached ? (0, _helperUtil.getDataFromLocalStorage)((0, _helperUtil.getLocalStorageCategoriesKey)(this.brandType), invalidCachedTime) : null;

                if (!localCategories) {
                  _context.next = 6;
                  break;
                }

                this.markInfo('Universal Header: Fetched categories from cache');
                return _context.abrupt("return", this.sortCategoryByRank(localCategories));

              case 6:
                startTime = new Date().getTime();
                this.markInfo('Universal Header:Fetching categories using api call');
                _context.prev = 8;
                dcSubnavConfig = (0, _helperUtil.getDataFromLocalStorage)((0, _helperUtil.getLocalStorageDCSubnavConfigKey)(this.brandType), this.invalidCachedTimeSubnavConfig);

                if (dcSubnavConfig) {
                  _context.next = 15;
                  break;
                }

                _context.next = 13;
                return (0, _fetchCatalogs.fetchSubnavConfig)(this.brandType);

              case 13:
                dcSubnavConfig = _context.sent;

                if (dcSubnavConfig) {
                  (0, _helperUtil.setDataToLocalStorage)((0, _helperUtil.getLocalStorageDCSubnavConfigKey)(this.brandType), dcSubnavConfig);
                }

              case 15:
                _context.next = 17;
                return (0, _fetchCatalogs.fetchCatalog)(activeContextStore, dcSubnavConfig);

              case 17:
                categories = _context.sent;
                _context.next = 26;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](8);
                this.markInfo('Universal Header:[FAILED] Fetched categories using api call');
                this.markInfo('Universal Header:[FAILED] Fetched Sub categories not initiate api call');
                console.error(_context.t0);
                return _context.abrupt("return");

              case 26:
                if (categories) {
                  _context.next = 28;
                  break;
                }

                return _context.abrupt("return");

              case 28:
                timeDiff = new Date().getTime() - startTime;
                this.markInfo('Universal Header:[SUCCESS] Fetched categories using api call');
                this.markInfo('Universal Header: Required time to fetch category details using api call ', timeDiff + ' ms ');

                if (this.enableLocalStorageCached) {
                  (0, _helperUtil.setDataToLocalStorage)((0, _helperUtil.getLocalStorageCategoriesKey)(this.brandType), categories);
                }

                return _context.abrupt("return", this.sortCategoryByRank(categories));

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 20]]);
      }));

      function _doFetchCatalog() {
        return _doFetchCatalog2.apply(this, arguments);
      }

      return _doFetchCatalog;
    }()
    /**
     * Fetch the categories JSON.
     */

  }, {
    key: "fetchCatalog",
    value: function fetchCatalog() {
      if (!this.fetchCatalogPromise) this.fetchCatalogPromise = this._doFetchCatalog();
      return this.fetchCatalogPromise;
    }
    /**
     * Listen for the category JSON data. The listener might be called twice, if we use mock data before
     * the real data loads.
     */

  }, {
    key: "listenToCatalog",
    value: function listenToCatalog(listener) {
      var _this = this;

      var promise = this.fetchCatalog();
      promise.then(function (categories) {
        if (!categories && _this.enableMockData) categories = _this.getMockCatalog();
        listener(categories);
      });

      if (this.enableMockData) {
        (0, _promiseUtil.ifPromiseUnresolved)(promise, USE_MOCK_DATA_AFTER_MS, function () {
          listener(_this.getMockCatalog());
        });
      }
    }
    /**
     * Fetch the flyout content DC. This is a private call wrapped by fetchFlyoutContent()
     */

  }, {
    key: "_doFetchFlyoutContent",
    value: function () {
      var _doFetchFlyoutContent2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var invalidCachedTime, flyoutContent, startTime, categories, dcRes, timeDiff;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                invalidCachedTime = this.invalidCachedTimeSubCategories;
                flyoutContent = this.enableLocalStorageCached ? (0, _helperUtil.getDataFromLocalStorage)((0, _helperUtil.getLocalStorageSubcategoriesKey)(this.brandType), invalidCachedTime) : null;

                if (!flyoutContent) {
                  _context2.next = 5;
                  break;
                }

                this.markInfo('Universal Header: Fetched Sub Categories from cache');
                return _context2.abrupt("return", flyoutContent);

              case 5:
                startTime = new Date().getTime();
                this.markInfo('Universal Header: Fetching sub categories using api call');
                _context2.next = 9;
                return this.fetchCatalog();

              case 9:
                categories = _context2.sent;
                _context2.prev = 10;
                _context2.next = 13;
                return (0, _fetchCatalogs.fetchSubCatData)(categories, this.brandType);

              case 13:
                dcRes = _context2.sent;
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](10);
                this.markInfo('Universal Header: [FAILED] Fetched sub categories using api call');
                this.loggerInstance.error('Error: while fetching sub categories data', 'fetchSubCatData', _context2.t0);
                return _context2.abrupt("return", null);

              case 21:
                if (dcRes) {
                  _context2.next = 23;
                  break;
                }

                return _context2.abrupt("return", null);

              case 23:
                timeDiff = new Date().getTime() - startTime;

                if (!dcRes) {
                  _context2.next = 29;
                  break;
                }

                this.markInfo('Universal Header: [SUCCESS] Fetched sub categories using api call');
                this.markInfo('Universal Header: Required time to fetch sub categories details using api call ', timeDiff + ' ms ');

                if (this.enableLocalStorageCached) {
                  (0, _helperUtil.setDataToLocalStorage)((0, _helperUtil.getLocalStorageSubcategoriesKey)(this.brandType), dcRes);
                }

                return _context2.abrupt("return", dcRes);

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10, 16]]);
      }));

      function _doFetchFlyoutContent() {
        return _doFetchFlyoutContent2.apply(this, arguments);
      }

      return _doFetchFlyoutContent;
    }()
  }, {
    key: "getMockFlyoutContent",
    value: function getMockFlyoutContent() {
      var categories = this.getMockCatalog();
      var mockContent = (0, _fetchCatalogs.fetchMockSubCatData)(categories, this.brandType);
      return mockContent;
    }
    /**
     * Fetch the flyout DC.
     */

  }, {
    key: "fetchFlyoutContent",
    value: function fetchFlyoutContent() {
      if (!this.fetchFlyoutContentPromise) this.fetchFlyoutContentPromise = this._doFetchFlyoutContent();
      return this.fetchFlyoutContentPromise;
    }
    /**
     * Listen for the flyout content data. The listener might be called twice, if we use mock data before
     * the real data loads.
     */

  }, {
    key: "listenToFlyoutContent",
    value: function listenToFlyoutContent(listener) {
      var _this2 = this;

      var promise = this.fetchFlyoutContent();
      promise.then(function (content) {
        if (!content && _this2.enableMockData) content = _this2.getMockFlyoutContent();
        listener(content);
      });

      if (this.enableMockData) {
        (0, _promiseUtil.ifPromiseUnresolved)(promise, USE_MOCK_DATA_AFTER_MS, function () {
          listener(_this2.getMockFlyoutContent());
        });
      }
    }
  }]);
  return CategoryDataCache;
}();

exports.default = CategoryDataCache;